import { render, staticRenderFns } from "./SaleView.vue?vue&type=template&id=271d5760&lang=pug"
import script from "./SaleView.vue?vue&type=script&lang=js"
export * from "./SaleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports